<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 mobile-layout">
      <md-card class="mobile-card appeals-card">
        <md-card-content class="mobile-content">
          <div class="appeals-page-wrapper">
            <div class="appeals-tab-wrapper">
              <appeals-tab-bar
                v-model="active"
                :completedDot="completedDot"
                :allAmount="statusCount.all"
                :activeAmount="statusCount.active"
                :finishedAmount="statusCount.finished"
                @input="onChangeTab"
              />
              <md-button class="hidden-sm" @click="$router.push({ name: 'CreateAppeal'})">
                Создать заявку
              </md-button>
            </div>
            <div v-if="list.length > 0" class="appeals-wrapper">
              <router-link
                class="appeal-item"
                v-for="(appeal, i) in list"
                :key="appeal.id"
                :to="{ name: 'AppealsDetail', params: { id: appeal.id }}"
              >
                <span class="red-dot" v-if="appeal.rating.awaiting"></span>
                <span
                  class="md-theme-list-head-color appeal-item__link">
                  №{{ appeal.number }} / {{ appeal.createdAt | date }}
                </span>
                <div class="wrap-rating" v-if="appeal.rating.id !== null">
                  <i class="material-icons icon-rating" :class="{'gold': appeal.rating.id > 0}">star</i>
                  <i class="material-icons icon-rating" :class="{'gold': appeal.rating.id > 1}">star</i>
                  <i class="material-icons icon-rating" :class="{'gold': appeal.rating.id > 2}">star</i>
                  <i class="material-icons icon-rating" :class="{'gold': appeal.rating.id > 3}">star</i>
                  <i class="material-icons icon-rating" :class="{'gold': appeal.rating.id > 4}">star</i>
                </div>
                <p v-if="appeal.category" class="appeal-item__cat text-main-black">
                  {{ appeal.category.fullName }}
                </p>
                <p class="text-main-black appeal-item__descr">
                  {{ appeal.description }}
                </p>
              </router-link>
              <a href="#" class="more-link md-theme-link" @click.prevent="nextPage" v-if="pageNext" >
                Показать больше
              </a>
            </div>
            <div v-else class="load-wrapper">
              <circle-loader v-if="loader" :diameter="48" />
              <span v-else class="description">У вас пока нет заявок</span>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import api from "@/api";
import to from "await-to-js";
import { mapGetters } from "vuex";
import AppealsTabBar from '@/apps/appeals/components/AppealsTabBar';
import CircleLoader from '@/components/Custom/CircleLoader';
import StarRatingControl from '@/components/Custom/StarRatingControl';

export default {
  name: "AppealsPage",
  components: {
    AppealsTabBar,
    CircleLoader,
    StarRatingControl,
  },
  data() {
    return {
      createModal: false,
      active: null,
      loader: false,
      list: [],
      statusCount: {
        all: 0,
        active: 0,
        finished: 0,
        ratingAwaiting: 0
      },
      pageNext: null,
    }
  },
  computed: {
    ...mapGetters([
      'getUsername'
    ]),

    completedDot() {
      return this.statusCount.ratingAwaiting > 0
    }
  },
  mounted() {
    this.$root.$on('createAppeal', this.toCreateAppeal)
    this.fetchAppeals(1);
  },
  beforeDestroy() {
    this.$root.$off('createAppeal', this.toCreateAppeal)
  },
  methods: {
    toCreateAppeal() {
      this.$router.push({ name: 'CreateAppeal'})
    },
    onChangeTab() {
      this.list = [];
      this.fetchAppeals(1)
    },
    nextPage() {
      this.fetchAppeals(this.pageNext);
    },
    async fetchAppeals(page) {
      const { active } = this;
      const params = {
        page,
        pageSize: 10,
        active,
        username: this.getUsername,
      }
      this.loader = true;
      const [err, resp] = await to(api.appeals.list(params));

      if (!err) {
        this.list = [ ...this.list, ...resp.data.results];
        this.statusCount = resp.data.statusCount;
        this.pageNext = resp.data.pageNext;
      }

      this.loader = false;
    },
  }
};
</script>

<style lang="scss" scoped>
.appeals-card {
  max-width: 785px;
  @media (max-width: 768px) {
    box-shadow: unset;
    height: calc(100vh - 65px);
    margin-bottom: 0;
  }
  .md-card-content {
    padding: 25px 20px;
    @media (max-width: 768px) {
      padding: 0 !important;
    }
  }
  .appeals-wrapper {
    @media (max-width: 768px) {
      background-color: transparent;
    }
  }
  .red-dot {
    display: inline-block;
    width: 7px;
    height: 7px;
    background-color: red;
    border-radius: 50%;
  }
  .more-link {
    padding: 10px 5px;
    display: block;
    max-width: 420px;
    text-align: center;
    margin: 20px 0;
    text-transform: uppercase;
    font-size: 12px;
  }
  .appeal-item {
    display: block;
    padding-top: 15px;
    padding-left: 15px;
    margin-bottom: 2px;
    background-color: #fff;
    &:not(:last-child) {
      border-bottom: 1px solid #eee;
    }
    &:hover {
      background-color: #f5f5f5;
    }
    &__link {
      font-weight: 700;
      letter-spacing: 1px;
    }
    &__descr {
      line-height: 22px;
      margin: 0 0 15px 0;
    }
    &__cat {
      color: #000000;
      font-weight: 500;
      margin: 0;
    }
  }
  .appeals-page-wrapper {
    padding: 0 10px;
    @media (max-width: 768px) {
      padding: 0;
    }
  }
  .appeals-tab-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    @media (max-width: 768px) {
      margin-top: -1px;
      padding: 10px 10px;
      background-color: var(--md-theme-main-bar-color);
    }
  }
  .load-wrapper {
    width: 100%;
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .create-btn-mobile {
    margin-left: 10px;
    display: none;
    @media (max-width: 768px) {
      display: block;
    }
  }
}
</style>
